import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-fzmarke-list-view',
  imports: [],
  templateUrl: './fzmarke.list-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FzmarkeListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
